export class ePrescription {
  prescription_id?: string;
  issue_date?: string;
  expiry_date?: string;
  description?: string;
  status?: number;
  status_desc?: string;
  is_open?: boolean;
  firstname?: string;
  lastname?: string;
  number_of_units_per_intake?: string;
  substitution?: string;
  strength?: string;
  package_size?: string;
  package_type_id?: string;
  route_of_administration_id?: string;
  instructions_to_dispencer?: string;
  instructions_to_patient?: string;
  duration?: string;
  duration_unit?: string;
  frequency_of_intake?: string;
  frequency_of_intake_unit_description?: string;
  quantity?: string;
  date_of_issue?: string;
  date_of_onset?: string;
  brand_name?: string;
  active_ingredient?: string;
  active_ingredient_id?: string;
  pharmaceutical_dose_form_id?: string;
  package_num?: string;
  extra_info?: {
    dispenser_telephone?: string;
    atc_code?: string;
    substitution?: string;
    strength?: string;
    route_of_administration?: string;
    dispenser_country?: string;
    brand_name?: string;
    packaging?: string;
    dispenser_name_surname?: string;
    pharmaceutical_dose_form?: string;
    date_of_dispense?: string;
    represented_organization_name?: string;
    package_num?: string;
  };
  [key: string]: any;
}
